module.exports = __webpack_public_path__ + "static/logo_royals-ca4fab4422ac44f990c60fae7ad80f46.png";